export const DEFAULT_BATTERY_FEE = '0'
